import { NodeModel } from "@minoru/react-dnd-treeview";

import { Widget } from "@/lib/api";

export function treeDataFromTabs(widgets: Widget[]) {
  return widgets.map<NodeModel<Widget>>((widget) => {
    return {
      parent: 0,
      id: widget.id,
      text: widget.id,
      droppable: true,
      data: widget,
    };
  });
}
